import axios from 'axios';
import { osndLocalStorage, storageConstant } from '../helpers/localStorageUtils';
import { replace } from 'connected-react-router';
import { type } from '../analytics/analyticsUtil';

// Add a request interceptor
axios.interceptors.request.use(
    (config) => {
        // Log the request headers
        if (config.headers?.query) {
            const kpiQuery = config.headers.query
                .replace('oslte_kpi_metrics_', '')
                .replace('{application="micrometer-oslte-kpi-service"', '')
                .replace(/ecpdId="\d+", /, '')
                .replace(', job="osnd-promotheus-service"}', '');
            console.log('KPI Query:', kpiQuery);
        }
        return config;
    },
    (error) => {
        // Do something with request error
        console.error('Request Error:', error);
        return Promise.reject(error);
    }
);

const { CancelToken, isCancel } = axios;

const getHeaderEnterpriseIds = () => {
    const linkedEnterprises = osndLocalStorage.getObject(storageConstant.LINKED_ENTERPRISES);
    let enterpriseIds = '';
    if (linkedEnterprises?.length > 0) {
        const isAllLocationsSelected = linkedEnterprises.find((enterprise) => enterprise.enterpriseId === 'all_locations')?.selected;
        if (isAllLocationsSelected || linkedEnterprises?.length > 1) {
            enterpriseIds = linkedEnterprises
                        .filter((enterprise) => (isAllLocationsSelected ? enterprise.enterpriseId !== 'all_locations' : enterprise.selected))
                        .map((enterprise) => enterprise.enterpriseId)
                        .join(',');
        } else {
            enterpriseIds = linkedEnterprises
                            .map((enterprise) => enterprise.enterpriseId)
                            .join(',');
        }

    }
    return enterpriseIds;
};

const getXsrfToken = () =>
    document.cookie.split('; ').find((row) => row.startsWith('XSRF-TOKEN='))?.split('=')[1];

const getHeaderConfig = (config = {}) => {
    const enterpriseIds = getHeaderEnterpriseIds();
    const xsrfToken = getXsrfToken();
    config.headers = {
        ...config.headers,
        ...(!config.headers?.['x-xsrf-token'] && xsrfToken && { 'x-xsrf-token': xsrfToken }),
        ...(enterpriseIds.length && { 'enterprise-ids': enterpriseIds })
    };
    return config;
};

const getOSNDHeaders = () => {
    const enterpriseIds = getHeaderEnterpriseIds();
    const headers = {
        'Content-Type': 'application/json'
    };
    if (enterpriseIds.length) {
        headers['enterprise-ids'] = enterpriseIds;
    }
    return headers;
};

const axiosInstance = axios.create({
    headers: getOSNDHeaders(),
    xsrfCookieName: '',
    xsrfHeaderName: ''
});

const downloadInstance = axios.create({
    headers: {
        ...getOSNDHeaders(),
        'Content-Type': 'application/octet-stream'
    }
});

const filesParams = (json, files) => {
    const formData = new FormData();

    let filesArr = files;

    if (!Array.isArray(files)) {
        filesArr = [files];
    }

    formData.append('params', new Blob([JSON.stringify(json)], { type: 'application/json' }), 'json');
    filesArr.forEach((file) => formData.append('file', file));

    return formData;
};

const requestGet = async (path, config = undefined) => {
    config = getHeaderConfig(config);
    return axiosInstance
        .get(path, config)
        .then((response) => response)
        .catch((error) => Promise.reject(error.response));
};

const requestGetAverageThroughput = (requestOne, config = undefined) =>
    axios
        .all([requestOne])
        .then(axios.spread((...responses) => responses))
        .catch((error) => Promise.reject(error.response));

const requestGetGraph = (
    requestOne,
    requestTwo,
    requestThree,
    requestFour,
    requestFive,
    requestSix,
    requestSeven,
    requestEight,
    requestNine,
    requestTen,
    requestEleven,
    requestTwelve,
    config = undefined
) =>
    Promise.all([
        requestOne,
        requestTwo,
        requestThree,
        requestFour,
        requestFive,
        requestSix,
        requestSeven,
        requestEight,
        requestNine,
        requestTen,
        requestEleven,
        requestTwelve
    ])
        .then(axios.spread((...responses) => responses))
        .catch((error) => Promise.reject(error.response));

const requestGetSloGraph = (
    requestOne,
    requestTwo,
    requestThree,
    requestFour,
    requestFive,
    requestSix,
    requestSeven,
    requestEight,
    requestNine,
    requestTen,
    request11,
    request12,
    request13,
    request14,
    request15,
    request16,
    request17,
    request18,
    request19,
    request20,
    request21,
    request22,
    request23,
    request24,
    request25,
    request26,
    request27,
    request28,
    request29,
    request30,
    request31,
    request32,
    request33,
    request34,
    request35,
    request36,
    request37,
    request38,
    request39,
    request40,
    request41,
    request42,
    request43
) =>
    Promise.all([
        requestOne,
        requestTwo,
        requestThree,
        requestFour,
        requestFive,
        requestSix,
        requestSeven,
        requestEight,
        requestNine,
        requestTen,
        request11,
        request12,
        request13,
        request14,
        request15,
        request16,
        request17,
        request18,
        request19,
        request20,
        request21,
        request22,
        request23,
        request24,
        request25,
        request26,
        request27,
        request28,
        request29,
        request30,
        request31,
        request32,
        request33,
        request34,
        request35,
        request36,
        request37,
        request38,
        request39,
        request40,
        request41,
        request42,
        request43
    ])
        .then(axios.spread((...responses) => responses))
        .catch((error) => Promise.reject(error.response));

const requestGetGraphMMECore = (requestOne, requestTwo, requestThree, requestFour, requestFive, requestSix, requestSeven, config = undefined) =>
    axios
        .all([requestOne, requestTwo, requestThree, requestFour, requestFive, requestSix, requestSeven])
        .then(axios.spread((...responses) => responses))
        .catch((error) => Promise.reject(error.response));

const requestGetNDACGraph = (requestOne, requestTwo, requestThree, requestFour, requestFive, requestSix, requestSeven, requestEight, requestNine, requestTen, config = undefined) =>
    axios
        .all([requestOne, requestTwo, requestThree, requestFour, requestFive, requestSix, requestSeven, requestEight, requestNine, requestTen].filter(req => req))
        .then(axios.spread((...responses) => responses))
        .catch((error) => Promise.reject(error.response));

const requestGetGraphCore = (requestOne, requestTwo, config = undefined) =>
    axios
        .all([requestOne, requestTwo])
        .then(axios.spread((...responses) => responses))
        .catch((error) => Promise.reject(error.response));

const requestGetSA5GAMFGraphCore = (requestOne, config = undefined) =>
    axios
        .all([requestOne])
        .then(axios.spread((...responses) => responses))
        .catch((error) => Promise.reject(error.response));

const requestGetDownload = async (path, config = undefined) => {
    config = getHeaderConfig(config);
    return downloadInstance
        .get(path, config)
        .then((response) => response)
        .catch((error) => {
            return Promise.reject({ error, canceled: isCancel(error) });
        });
};

const requestPost = async (path, json, config = undefined) => {
    config = getHeaderConfig(config);
    return axiosInstance
        .post(path, json, config)
        .then((response) => response)
        .catch((error) => {
            return Promise.reject(error.response);
        });
};

const requestPut = async (path, json, config = undefined) => {
    config = getHeaderConfig(config);
    return axiosInstance
        .put(path, json, config)
        .then((response) => response)
        .catch((error) => Promise.reject(error.response));
};

const requestDelete = async (path, json = {}, config = {}) => {
    config = getHeaderConfig(config);
    return axiosInstance
        .delete(path, json ? { ...config, data: { ...json } } : config)
        .then((response) => response)
        .catch((error) => Promise.reject(error.response));
};

const requestPostFiles = async (path, json, files, config = {}) => {
    const formData = filesParams(json, files);

    let headers = {
        ...config.headers,
        'Content-Type': 'multipart/form-data'
    };

    const enterpriseIds = getHeaderEnterpriseIds();
    if (enterpriseIds.length) {
        headers['enterprise-ids'] = enterpriseIds;
    }

    const formConfig = {
        ...config,
        headers
    };

    return axiosInstance
        .post(path, formData, formConfig)
        .then((response) => response)
        .catch((error) => Promise.reject(error.response));
};

const requestPostDownload = (path, data, config = undefined) => {
    return downloadInstance
        .post(path, data, config)
        .then((response) => response)
        .catch((error) => {
            return Promise.reject({ error, canceled: isCancel(error) });
        });
};

const loginParams = (user, pass, rememberMe) => {
    const params = new URLSearchParams();

    params.append('username', user);
    params.append('password', pass);
    params.append('rememberMe', rememberMe);

    return params;
};

// Login Requests

// Verify username and password.
const login = (user, pass, rememberMe) =>
    requestPost('/login/standalone', loginParams(user, pass, rememberMe), {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
    })
        .then((response) => response)
        .catch((error) => Promise.reject(error));

// Logout Request
const sessionCleanup = () => requestDelete('/session/cleanup');

// Websocket Token
const getWebsocketToken = () => requestGet('/api/v1/user/ws/token');

// Admin user login/logout of enterprise
const adminGetEnterprises = (filters) => requestPost('/api/v1/admin/enterprises', filters);
const adminLogin = (enterpriseId) => requestPut('/session', { enterpriseId });
const adminLogout = (enterpriseId) => requestDelete('/session', { enterpriseId });

// Session check requests (on timer)
const session = () => requestGet('/session');

// Registration Requests

// Step 1 -- Verify the user
const verifyRegistration = (code) => requestGet(`/code/${code}`);

// Step 2 - User finishes registration form
const submitRegistration = (form) => requestPost('/registration', form);

// Forgot Password Requests

// Step 1 -- Send forgot password request
const submitReset = (form) => requestPost('/reset', form);

// Step 2 -- Verify the token emailed to user
const verifyReset = (token) => requestGet(`/reset/verify/${token}`);

// Step 3 - User finishes change password form
const updateReset = (form) => requestPost('/reset/update', form);

// Fetching authorized locations assigned to user
const locations = () => requestGet('/api/v1/user/config');

// Step 1 -- Add SIMs Single - get profiles
const getSimProfiles = () => requestGet('/api/v1/SIM/profileoptions');
const getSimHWGroups = (locationId) => requestGet(`/api/v1/SIM/${locationId}/nhgoptions`);

const getDashboardWidgets = (payload) => requestPost('/api/v1/dashboard/view', payload);
const getDashboardDeviceCounts = () => requestGet('/api/v1/dashboard/devices');

// Step 2 -- Add SIMs Single - submit form
const submitAddSimSingle = (form) => requestPost(`/api/v1/SIM/addSIM`, form);

const validateDuplicateStaticIp = (locationId, ip) => requestGet(`/api/v1/devices/monitoring/checkStaticIp/${locationId}/${ip}`);
// Step 1 -- Add SIMs Bulk - submit form, upload files
const submitAddSimBulk = (form, files, progressCallback) =>
    requestPostFiles('/api/v1/SIM/addmultipleSIMs', form, files, { onUploadProgress: progressCallback });

// Step 1 -- Add User - get enterprise roles
// Step 1 -- Modify User - get enterprise roles and existing user info
const initManageUser = (userId, config = {}) =>
    userId ? requestGet(`/api/v1/user/initmodify/${userId}`, config) : requestGet('/api/v1/user/initadd', config);

// Step 1 -- get UserIds - based on email
// Step 1 -- Modify UserIds - based on email

const initManageIdsUser = (email) => (email ? requestPost('/api/v1/myBiz/userInfo', email) : requestPost('/api/v1/myBiz/userInfo', email));

// Step 2 -- Add User - submit form
// Step 2 -- Modify User - submit form
const submitManageUser = (form, config = {}) =>
    form.id ? requestPut('/api/v1/user/modify', form, config) : requestPost('/api/v1/user/add', form, config);

// Step 1 -- Add/ModifyInit Roles
const getEnterprisePermissions = (userId) => {
    return userId ? requestGet(`/api/v1/role/initmodify/${userId}`) : requestGet('/api/v1/role/initadd');
};

// Step 2 -- Add/Modify Roles - submit form
const submitAddRole = (form) => {
    return form.id ? requestPut('/api/v1/role/modify', form) : requestPost('/api/v1/role/add', form);
};

const getCount = (filter) => requestPost('/api/v1/SIMs/Counts', filter);
// Step 1 -- View Users
// const viewUsers = (filter) => requestPost("/api/v1/users", filter);filter
const viewUsers = (filters, config = {}) => requestPost('/api/v1/users/view', filters, config);
const usersCount = () => requestGet('/api/v1/users/counts');
const userOptions = () => requestGet('/api/v1/users/options');
const updateUsers = (config) => requestPut('/api/v1/users/updateUsers', config);
const deleteUser = (config) => requestDelete('/api/v1/users/deleteUsers', config);

const viewRoles = (filters, config = {}) => requestPost('/api/v1/roles/view', filters, config);
const viewSims = (filter) => requestPost('/api/v1/SIMs/view', filter);

const removeUsers = (selected, config = {}) => requestPost('/api/v1/users/remove', selected, config);
const removeRoles = (selected) => requestPost('/api/v1/roles/remove', selected);

const updateSims = (update) => requestPut('/api/v1/SIMs/modify', update);
const removeSims = (selected) => requestPost('/api/v1/SIMs/remove', selected);
const typeAheadSims = (filterType, searchKey, locationId) => requestGet(`/api/v1/SIMs/location/${locationId}/${filterType}/${searchKey}`);

const viewBackups = (filters) => requestPost('/api/v1/backups/view', filters);
const removeBackups = (selected) => requestPost('/api/v1/backup/remove', selected);
const saveBackup = (form) => requestPost('/api/v1/backup/schedule', form);
const runBackup = (locationId) => requestPost(`/api/v1/backup/location/${locationId}/now`);
const preserveBackups = (payload) => requestPost('/api/v1/backups/preserveBackup', payload);

const downloadBackup = (file, progressCallback, setupCancelerCallback, locationId) =>
    requestGetDownload(`/api/v1/backup/location/${locationId}/download/${file}`, {
        onDownloadProgress: progressCallback,
        cancelToken: new CancelToken((cancelerCallback) => setupCancelerCallback(cancelerCallback))
    });

const viewAudits = (viewRequest) => requestPost(`/api/v1/audit`, viewRequest);
const downloadAudit = (filename, progressCallback, setupCancelerCallback, locationId) =>
    requestGetDownload(`/api/v1/audit/download/location/${locationId}/${filename}`, {
        onDownloadProgress: progressCallback,
        cancelToken: new CancelToken((cancelerCallback) => setupCancelerCallback(cancelerCallback)),
        responseType: 'arraybuffer'
    });

const removeAudits = (auditId, auditDate) => requestPost('/api/v1/auditDelete', auditId, auditDate);
const runAudit = () => requestGet(`/api/v1/auditNow/`);
const saveAudit = (form) => requestPost('/api/v1/audit/schedule', form);

const viewRestore = (viewRequest) => requestPost(`/api/v1/restore`, viewRequest);
const downloadRestore = (filepath, progressCallback, setupCancelerCallback, locationId) =>
    requestPostDownload(
        `/api/v1/restore/download/location/${locationId}`,
        { filepath },
        {
            onDownloadProgress: progressCallback,
            cancelToken: new CancelToken((cancelerCallback) => setupCancelerCallback(cancelerCallback)),
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    );

const removeRestore = (restoreId, restoreDate) => requestPost('/api/v1/restoreDelete', restoreId, restoreDate);
const runRestore = () => requestGet(`/api/v1/restoreNow`);
// const saveRestore = (form) => requestPost('/api/v1/restore/schedule', form);

//directory sync page:
const getConfig = () => requestGet(`/api/v1/directory/sync/config`);
const updateConfig = (config) => requestPost('/api/v1/directory/sync/config', config);
const generateKey = (payload) => requestPost('/api/v1/directory/generateToken', payload);
const resetSecret = (payload) => requestPost('/api/v1/directory/resetSecret', payload);

// Step 1 -- View Sim
const viewSim = (id, locationId) => requestGet(`/api/v1/SIM/location/${locationId}/${id}`);

// Step 2 -- View Sim
const updateSim = (form) => requestPut('/api/v1/SIM/modify', form);

const viewDeviceName = (locationId, imei) => requestGet(`api/v1/simLock/${locationId}/imei/${imei}`);

const lockSim = (form) => requestPost('/api/v1/simLock', form);
const unlockSim = (form) => requestPost('/api/v1/simLock/remove', form);

const viewImei = (locationId, imsi) => requestGet(`/api/v1/simLock/${locationId}/imsi/${imsi}`);
const replaceImei = (form) => requestPost('/api/v1/simLock/replace', form);

const viewApns = (locationId) => requestGet(`/api/v1/SIM/apns?locationId=${locationId}`);
const viewFilteredApns = (simType) => requestGet(`/api/v1/SIM/filteredapns${simType ? `?simType=${simType}` : ''}`);
const viewLocationApns = () => requestGet(`/api/v1/SIM/location/apns`);
const suggestIp = (form) => requestPost('/api/v1/SIM/nextIp', form);
const getSMDPFqdn = () => requestGet('/api/v1/smdpconfig');

const suggestSim = (form) => requestPost('/api/v1/SIM/profile/ip', form);
const getHelpFile = () => requestGet('/api/v1/usermanual');
const getVideoGuideFile = () => requestGet('/api/v1/helpvideo');
const getJourneyGuideFile = (installationType) => requestGet(`/api/v1/journeyGuide/${installationType}`);

const typeAheadDevice = (locationId, name, searchKey) => requestGet(`/api/v1/devices/location/${locationId}/${name}/${searchKey}`);
const viewDevices = (filters) => requestPost('/api/v1/devices/monitoring/view', filters);
const viewDeviceCounts = (locationId) => requestGet(`/api/v1/devices/monitoring/${locationId}/counts`);
const imsiInfo = (locationId, imsi) => requestGet(`/api/v1/devices/monitoring/${locationId}/${imsi}/imsiInfo`);
const imsiDataUsage = (locationId, imsi) => requestGet(`/api/v1/devices/monitoring/${locationId}/${imsi}/imsiDataUsage`);

const getUserPreference = () => requestGet('/api/v1/user/preference');
const savePreference = (updatePreference) => requestPut('/api/v1/user/updatePreference', updatePreference);
const refreshDevices = (filters) => requestPost('/api/v1/devices/monitoring/refresh', filters);

// Audit Logs
const viewAuditLogs = (filters) => requestPost('/api/v1/log/fetch', filters);
const downloadAuditLogs = (filters) => requestPost('/api/v1/log/fetch', { ...filters, download: true });

const getCustomDeviceNames = () => requestGet('/api/v1/user/customDeviceNames');
const saveCustomDeviceName = (customDevice) => requestPost('/api/v1/user/customDeviceName', customDevice);

const getStatusOptions = () => requestGet('/api/v1/ticketing/statusoptions');
const getTicketsCount = (fromDate, toDate) => requestGet(`/api/v1/ticketing/counts?fromDate=${fromDate}&toDate=${toDate}`);
const viewTicketing = (filters) => requestPost('/api/v1/ticketing/view', filters);
const downloadTickets = (filters) => requestPost('/api/v1/ticketing/download', filters);
const ticketReport = (filters) => requestPost('/api/v1/ticketing/report', filters);
const viewTicket = (ticketId) => requestGet(`/api/v1/ticketing/ticket/${ticketId}`);

const viewRestorationTicketing = (filters) => requestPost('/api/v2/ticketing/view', filters);
const downloadRestorationTickets = (filters) => requestPost('/api/v2/ticketing/download', filters);
const ticketRestorationReport = (filters) => requestPost('/api/v2/ticketing/report', filters);
const ticketAvailabilityCounts = (filters) => requestPost('/api/v2/ticketing/availabilityTime', filters);
const viewRestorationTicket = (ticketReferenceNumber) => requestGet(`/api/v2/ticketing/ticket/${ticketReferenceNumber}`);

// Step 1 -- View Inventory
const inventoryView = (locationId) => requestPost(`/api/v1/inventory/view`, locationId);
const updateNetworkDetails = (payload) => requestPut(`/api/v1/inventory/info/modify`, payload);
const multiSiteInventoryView = (locationId) => requestGet(`/api/v1/inventory/multi-site`);
const floorPlanView = (locationId) => requestPost(`/api/v1/ibwaveProjectData/view`, locationId);
const renewView = () => requestPost(`/api/v1/ibwave/renewFloorPlan`);

const offlineNodes = (locationId) => requestGet(`/api/v1/inventory/offline/nodes/${locationId}`);

const downloadInventory = (progressCallback, setupCancelerCallback, locationId) =>
    requestGetDownload(`/api/v1/inventory/export/location/${locationId}`, {
        onDownloadProgress: progressCallback,
        cancelToken: new CancelToken((cancelerCallback) => setupCancelerCallback(cancelerCallback))
    });

const inBuildingView = () => requestGet('/api/v1/inventory/viewInBuilding');

// Step 1 -- Add User - get enterprise roles
const getRolesAndEnterprises = (id) => {
    if (id) {
        return requestGet(`/api/v1/user/initmodify/${id}`);
    }
    return requestGet('/api/v1/user/initadd');
};

const submitAddEnterpriseOld = (json) => requestPost('/api/v0/enterprise/add', json);

const viewEnterprises = (filters) => requestPost('/api/v1/enterprises', filters);
const manageEnterprises = (json) => requestPost('/api/v1/enterprises/manage', json);

const getEnterpriseInfo = (id) => requestGet(`/api/v1/enterprise/roleoptions/${id}`);

const submitAddEnterpriseUser = (json) => requestPost('/api/v1/enterprise/user/add', json);

const initNowConfiguration = (id) => requestGet(`/api/v1/enterprise/NoWconfig/init/${id}`);
const submitNowConfiguration = (json) => requestPost('/api/v1/enterprise/location/NoWconfig/add', json);
const submitNowStatus = (json) => requestPut('/api/v1/enterprise/location/NoWconfig/status', json);

const initSimProfileService = (id) => requestPost(`/api/v1/enterprise/profiles/view`, id);
const simProfileRequest = (json) => requestPost('/api/v1/enterprise/profile/add', json);
const removeSimProfile = (json) => requestPost(`/api/v1/enterprise/profile/remove`, json);
const modifySimProfile = (json) => requestPost('/api/v1/enterprise/profile/modify', json);

// Performance API

const kpiView = (json) => requestPost('/api/v1/overallview/threshold', json);
const kpiThresoldModify = (json) => requestPut('/api/v1/overallview/modify', json);
const kpiThresoldDefault = (json) => requestPut('/api/v1/overallview/reset', json);
const kpiExfoView = (json) => requestPost('/api/v1/overallview/exfo/threshold', json);
const kpiThresoldExfoModify = (json) => requestPut('/api/v1/overallview/exfo/modify', json);
const kpiThresoldExfoDefault = (json) => requestPut('/api/v1/overallview/exfo/reset', json);
const kpiViewFls = (json) => requestPost('/api/v1/overallview/threshold_fls', json);
const kpiThresoldFlsModify = (json) => requestPut('/api/v1/overallview/modify_fls', json);
const kpiThresoldFlsDefault = (json) => requestPut('/api/v1/overallview/reset_fls', json);
const downloadGenerateReport = (progressCallback, setupCancelerCallback, locationId) =>
    requestGetDownload(`/api/v1/kpi/generate/location/${locationId}`, {
        onDownloadProgress: progressCallback,
        cancelToken: new CancelToken((cancelerCallback) => setupCancelerCallback(cancelerCallback))
    });

const graphDataCore = (json1, json2) => requestGetGraphCore(json1, json2);
const graphDataMMECore = (json1, json2, json3, json4, json5, json6, json7) => requestGetGraphMMECore(json1, json2, json3, json4, json5, json6, json7);

const graphDataRadio = (res1, res2, res3, res4, res5, res6, res7, res8, res9, res10, res11, res12) =>
    requestGetGraph(res1, res2, res3, res4, res5, res6, res7, res8, res9, res10, res11, res12);
const sloGraphDataRadio = (
    res1,
    res2,
    res3,
    res4,
    res5,
    res6,
    res7,
    res8,
    res9,
    res10,
    res11,
    res12,
    res13,
    res14,
    res15,
    res16,
    res17,
    res18,
    res19,
    res20,
    res21,
    res22,
    res23,
    res24,
    res25,
    res26,
    res27,
    res28,
    res29,
    res30,
    res31,
    res32,
    res33,
    res34,
    res35,
    res36,
    res37,
    res38,
    res39,
    res40,
    res41,
    res42,
    res43
) =>
    requestGetSloGraph(
        res1,
        res2,
        res3,
        res4,
        res5,
        res6,
        res7,
        res8,
        res9,
        res10,
        res11,
        res12,
        res13,
        res14,
        res15,
        res16,
        res17,
        res18,
        res19,
        res20,
        res21,
        res22,
        res23,
        res24,
        res25,
        res26,
        res27,
        res28,
        res29,
        res30,
        res31,
        res32,
        res33,
        res34,
        res35,
        res36,
        res37,
        res38,
        res39,
        res40,
        res41,
        res42,
        res43
    );
const graphDataSA5GAMFCore = (json1) => requestGetSA5GAMFGraphCore(json1);
const averageThroughput = (json1) => requestGetAverageThroughput(json1);
const ndacCoreGraph = (json1, json2, json3, json4, json5) => requestGetNDACGraph(json1, json2, json3, json4, json5);
const kpiOverallUsage = (json) => requestPost('/api/v1/overallview/usage', json);

// IBWave APIs
// ### Remove this hardcoded
const getFloorPlanView = (json) => requestPost(`/api/v1/ibwaveProjectData/view`, json);
const getFloorPlanImage = (payload) => requestPost(`/api/v1/floorplanimage`, payload);
const getGISConfig = (id) => requestGet(`/api/v1/gisconfig/${id}`);
const getMapAvailability = (id) => requestGet(`/api/v1/indoorOutdoorMap/Availability`);

// Notifications Alerts
const viewUserNotifications = () => requestGet('/api/v1/notifications');
const deleteUserNotification = (id) => requestPut(`/api/v1/notifications/${id}`);

// Atlas actions
const prepopulateUsers = () => requestGet('/api/v1/atlas/prepopulate');

const fetchInstances = (region) => requestGet(`/api/v1/instancesByRegion/${region}`);
const fetchCloudWatchMetrics = (payload) => requestPost(`/api/v1/cloudWatch/metrics`, payload);

const fetchMultiNibOverviewMetrics = () => requestPost(`/api/v1/multisite/overallview/threshold`, {});
const saveMultiNibOverviewMetrics = (payload) => requestPut(`/api/v1/multisite/overallview/modify`, payload);
//TODO: update the URI once API is ready on OSLTE-8600
const viewNewFeatureContent = (payload) => requestPost(`/api/v1/newFeatureContent`, payload);

const fetchPwnTracker = () => requestGet(`/api/v1/tracker`);

// Alert Rules APIs
const viewAlertRules = (filters) => requestPost('/api/v1/alert/rule/view', filters || {});
const getAlertRule = (id) => requestGet(`/api/v1/alert/rule/${id}`);
const createAlertRule = (payload) => requestPost('/api/v1/alert/rule', payload);
const updateAlertRule = (id, payload) => requestPut(`/api/v1/alert/rule/${id}`, payload);
const deleteAlertRule = (id) => requestDelete(`/api/v1/alert/rule/${id}`);

// Alert List APIs
const viewAlerts = (filters) => requestPost('/api/v1/alerts', filters || {});
const updateAlerts = (payload) => requestPut('/api/v1/alerts', payload);
const getAlertCounts = () => requestGet('/api/v1/alerts/counts');

export default {
    session,

    adminLogin,
    adminLogout,

    login,
    sessionCleanup,

    getWebsocketToken,

    adminGetEnterprises,

    verifyRegistration,
    submitRegistration,

    submitReset,
    verifyReset,
    updateReset,

    locations,

    getSimProfiles,
    getSimHWGroups,
    submitAddSimSingle,
    submitAddSimBulk,

    getDashboardWidgets,
    getDashboardDeviceCounts,

    initManageUser,
    submitManageUser,

    getEnterprisePermissions,
    submitAddRole,

    viewUsers,
    viewRoles,
    usersCount,
    userOptions,
    updateUsers,
    deleteUser,
    viewSims,

    removeUsers,
    removeRoles,

    updateSims,
    removeSims,
    typeAheadSims,

    viewBackups,
    removeBackups,
    saveBackup,
    runBackup,
    preserveBackups,
    downloadBackup,

    viewAudits,
    downloadAudit,
    runAudit,
    removeAudits,
    saveAudit,

    viewRestore,
    downloadRestore,
    runRestore,
    removeRestore,
    // saveRestore,

    getConfig,
    updateConfig,
    generateKey,
    resetSecret,

    viewSim,
    updateSim,

    viewDeviceName,
    lockSim,
    unlockSim,
    viewImei,
    replaceImei,
    viewApns,
    viewFilteredApns,
    viewLocationApns,
    suggestIp,
    getSMDPFqdn,

    typeAheadDevice,
    viewDevices,
    refreshDevices,
    viewDeviceCounts,
    imsiInfo,
    imsiDataUsage,

    getStatusOptions,
    getTicketsCount,
    viewTicketing,
    viewTicket,
    downloadTickets,
    ticketReport,

    viewRestorationTicketing,
    downloadRestorationTickets,
    ticketRestorationReport,
    ticketAvailabilityCounts,
    viewRestorationTicket,

    inventoryView,
    updateNetworkDetails,
    multiSiteInventoryView,
    floorPlanView,
    downloadInventory,
    renewView,
    inBuildingView,

    getRolesAndEnterprises,
    submitAddEnterpriseOld,
    viewEnterprises,
    manageEnterprises,
    getEnterpriseInfo,
    submitAddEnterpriseUser,
    initNowConfiguration,
    submitNowConfiguration,
    submitNowStatus,
    initSimProfileService,
    simProfileRequest,
    removeSimProfile,
    modifySimProfile,
    kpiView,
    kpiThresoldModify,
    kpiThresoldDefault,
    kpiExfoView,
    kpiThresoldExfoModify,
    kpiThresoldExfoDefault,
    kpiViewFls,
    kpiThresoldFlsModify,
    kpiThresoldFlsDefault,
    downloadGenerateReport,
    graphDataCore,
    graphDataMMECore,
    graphDataRadio,
    sloGraphDataRadio,
    graphDataSA5GAMFCore,
    requestGetNDACGraph,
    ndacCoreGraph,
    averageThroughput,
    initManageIdsUser,
    getFloorPlanView,
    getFloorPlanImage,
    getGISConfig,
    getMapAvailability,
    getUserPreference,
    savePreference,
    saveCustomDeviceName,
    getCustomDeviceNames,
    viewAuditLogs,
    downloadAuditLogs,
    validateDuplicateStaticIp,
    getCount,
    suggestSim,
    getHelpFile,
    getVideoGuideFile,
    getJourneyGuideFile,
    kpiOverallUsage,
    viewUserNotifications,
    deleteUserNotification,
    offlineNodes,
    prepopulateUsers,
    fetchInstances,
    fetchCloudWatchMetrics,
    fetchMultiNibOverviewMetrics,
    saveMultiNibOverviewMetrics,
    viewNewFeatureContent,
    fetchPwnTracker,

    // Alert Rules
    viewAlertRules,
    getAlertRule,
    createAlertRule,
    updateAlertRule,
    deleteAlertRule,

    // Alert List
    viewAlerts,
    updateAlerts,
    getAlertCounts
};
